import { render, staticRenderFns } from "./RootAdminView.vue?vue&type=template&id=a3ec2700&scoped=true&"
import script from "./RootAdminView.vue?vue&type=script&lang=js&"
export * from "./RootAdminView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ec2700",
  null
  
)

export default component.exports